import React, { Component, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Link,Badge,Checkbox, Select,MenuItem,ListItemText, InputLabel, Box, FormControl,OutlinedInput, Container, Grid, Card, CardContent, CardHeader, Divider, Typography, Icon, LinearProgress, linearProgressClasses, CardActions, Button, Chip, CircularProgress, TextField , Radio, Dialog, DialogTitle, CardActionArea} from '@mui/material';
import AddShoppingCart from '@mui/icons-material/AddShoppingCart'
import { Modal } from '@mui/material';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import moment from 'moment';
import { Helmet } from 'react-helmet';
import * as _ from 'lodash'
import FormLabel from '@mui/material/FormLabel'
import StyledDropzone from 'src/components/pages/reports/StyledDropzone'
import { _freedomAxios,_axios, _hrwinStageAxios } from 'src/plugins/axios';
import { Notify } from 'src/components/common/Notify';
import { styled } from '@mui/material/styles';
import commonService from 'src/service/common';

export default function EmployeeAddition () {

    const [entityId, setEntityId] = React.useState('');
    const [corporateList, setCorporateList] = React.useState([]);
    const[action, setAction] = React.useState('');
    const [uplaodStatus, setuploadStatus] = React.useState(false);
    const ActionPerform = ["Login Creation", "Vas Addition"]
    const sampleFileUrl = {"Login Creation" : "https://vasadd.s3.ap-south-1.amazonaws.com/static/UserCreation.xlsx?response-content-disposition=inline&X-Amz-Security-Token=IQoJb3JpZ2luX2VjELv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCmFwLXNvdXRoLTEiRzBFAiEA%2FNDJzBZh5fwxuDm%2F3CL62QK6tckaNWYFY8ZTW3QA0dcCIF8%2BDWu%2BhV8Ii%2FVBQWvPGkaAAH8zrF%2BHdHbP1zeiqJERKvsCCCUQAhoMNDU0MjY4MjM1MzY3IgzXfEuYGPDfLtfnbPcq2AIalmpJzS1tEvXL6UvIsO5XKPCBr4Ka9lrwpw6cRF69EVIFrQhsHon5z5%2BYZIHbXjA7T%2Fkikk7hNH%2Bsqm3HjHUPiTmEiT0hwiMyhi3J%2F37Dxo4qEUj3jKMWFXwzedAc%2BQmbLE62aEe0Qg9OB4FooPbTBexAgszb7N0n9z%2Bl%2FIUpqY2Etqy9MUGTi13AqJ9BO6BBJBJXKOxureRogJlVcABnnyTjmRzhGpB40F1BEB2%2BNdNVY0EnN9gYfbaVO28pwFDUY9Nvqys7D0K%2FlMGsLB2vUR46dBsdeM77xRdT9HOLfrR9JUDsSM3mWkPaEMtCeEZLGRCh%2FKEk1nTDgXrJ9%2B%2FaHIjG7ElO2HnyuCfhNK4SlO8nviuisC8gzcs67EW71IXx9jdfjeA1sFkx2HMS%2FGG9gEfZJxzx3iA7HHACZr%2BnxFkBjUOxU3W6tWMRpmLYPzBayKe%2BMDOWmDDqxfuQBjqzAmJYl4Jnxm1B3BI2j7qPrlMJCs5RH0QHGM90Q92eiUTPubGq4pKE3Ai85%2BvaPs8AKtCKTqPXTpLnhW19aj2%2FuQ2QpxPw5aG2QScyhA713uiGX0RPOb4tl2iJ6brZz3AfAbz6lfOPYNb2pTn56pM7%2BuzjSh99u6JA25f8yPGuqg1A0aKAB8ZZREeU5yrl1LYTK%2BRiALb9AdJKnbwM4gLVd7TAGFjGvr%2Bd%2FM6p2YbrfnX0EpMrEAUr4gYQwv%2F1flNbvmUYzfRR8bbYTE6OeVr9N2D3HU4KPqRVi8ahUXW3Nz%2Fq6UjkkIqkAM9e%2F%2Fs%2Bl7GoBQFpt3BKDbwdYNmvtwPZGLQ6Zz34GR0IBV3e8MaYLuK6UmqZtw1Xll3hUgwdVnvN6yZW5qBvNwuKYJh6qjcojBA%2BNgE%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20220302T032514Z&X-Amz-SignedHeaders=host&X-Amz-Expires=604799&X-Amz-Credential=ASIAWTRD7FZTSJ66QLXS%2F20220302%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Signature=a9519e5b452a847eb2c9434dd871ee9bce71561913b30ea7a36355f16dd57bf7",
     "Vas Addition" : "https://vasadd.s3.ap-south-1.amazonaws.com/static/BeneficiaryAddition.xlsx?response-content-disposition=inline&X-Amz-Security-Token=IQoJb3JpZ2luX2VjELv%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCmFwLXNvdXRoLTEiRzBFAiEA%2FNDJzBZh5fwxuDm%2F3CL62QK6tckaNWYFY8ZTW3QA0dcCIF8%2BDWu%2BhV8Ii%2FVBQWvPGkaAAH8zrF%2BHdHbP1zeiqJERKvsCCCUQAhoMNDU0MjY4MjM1MzY3IgzXfEuYGPDfLtfnbPcq2AIalmpJzS1tEvXL6UvIsO5XKPCBr4Ka9lrwpw6cRF69EVIFrQhsHon5z5%2BYZIHbXjA7T%2Fkikk7hNH%2Bsqm3HjHUPiTmEiT0hwiMyhi3J%2F37Dxo4qEUj3jKMWFXwzedAc%2BQmbLE62aEe0Qg9OB4FooPbTBexAgszb7N0n9z%2Bl%2FIUpqY2Etqy9MUGTi13AqJ9BO6BBJBJXKOxureRogJlVcABnnyTjmRzhGpB40F1BEB2%2BNdNVY0EnN9gYfbaVO28pwFDUY9Nvqys7D0K%2FlMGsLB2vUR46dBsdeM77xRdT9HOLfrR9JUDsSM3mWkPaEMtCeEZLGRCh%2FKEk1nTDgXrJ9%2B%2FaHIjG7ElO2HnyuCfhNK4SlO8nviuisC8gzcs67EW71IXx9jdfjeA1sFkx2HMS%2FGG9gEfZJxzx3iA7HHACZr%2BnxFkBjUOxU3W6tWMRpmLYPzBayKe%2BMDOWmDDqxfuQBjqzAmJYl4Jnxm1B3BI2j7qPrlMJCs5RH0QHGM90Q92eiUTPubGq4pKE3Ai85%2BvaPs8AKtCKTqPXTpLnhW19aj2%2FuQ2QpxPw5aG2QScyhA713uiGX0RPOb4tl2iJ6brZz3AfAbz6lfOPYNb2pTn56pM7%2BuzjSh99u6JA25f8yPGuqg1A0aKAB8ZZREeU5yrl1LYTK%2BRiALb9AdJKnbwM4gLVd7TAGFjGvr%2Bd%2FM6p2YbrfnX0EpMrEAUr4gYQwv%2F1flNbvmUYzfRR8bbYTE6OeVr9N2D3HU4KPqRVi8ahUXW3Nz%2Fq6UjkkIqkAM9e%2F%2Fs%2Bl7GoBQFpt3BKDbwdYNmvtwPZGLQ6Zz34GR0IBV3e8MaYLuK6UmqZtw1Xll3hUgwdVnvN6yZW5qBvNwuKYJh6qjcojBA%2BNgE%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20220302T032914Z&X-Amz-SignedHeaders=host&X-Amz-Expires=604800&X-Amz-Credential=ASIAWTRD7FZTSJ66QLXS%2F20220302%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Signature=a09129dcd0c2e9afb058e899f5f36942f91fb0321fbc999a171be72e28d3daa8"}
    const entityIdList = () => {
        _freedomAxios
        .post('corporate/getEntity', {"entityType" : 4653})
        .then((response) => {
             if(response.data.isSuccess){
                 let list = JSON.parse(response.data.result);
                setCorporateList(list);
             } 
        })
        .catch((error) => {
    
        })
    } 
 
    const checkEntityId = (id) => {
        let payLoad = {
            entityId : id
        };
        _freedomAxios
        .post('/corporate/getEntity',payLoad)
        .then((response) => {
            if(response.data.isSuccess){
               return true;
            }
            return response.data.message;
        })
        .catch((err) => {
            return false;
        })
    }

    const downloadFile = (url) => {
        var link = document.createElement("a");
        link.setAttribute('download', '');
        link.href = url;
        document.body.appendChild(link);
        link.click();
        link.remove();
      }

    const vasAddition = (files, type) => {
        const file = new FormData()
        file.append('vasAddition', files[0])
        file.append('filename', files[0].name)
        file.append('requestInExcelForm', 1)
        file.append('entityId', entityId),
        file.append('appId', 20000)
        if(type) {
            file.append('type', type)
        }

        _hrwinStageAxios
        .post('ahcOnboarding/vasAddition/vasAddition', file,
            {
                ignoreLoading: true,
                headers:{
                  authtoken: commonService.getAuthToken(),
                  'Content-Type': 'application/json'
                }
              }
        )
        .then((response) => {
            if(response.data.isSuccess){
                if(response.data.preSignedUrl.length > 0){
                        downloadFile(response.data.preSignedUrl);
                }
            }
        })
    }

    const profileCreation = (files, type) => {
        let payload = {};
        const file = new FormData()
        file.append('userCreation', files[0])
        file.append('filename', files[0].name)
        file.append('requestInExcelForm', 1)
        file.append('entityId', entityId),
        file.append('appId', 20000)
        if(type) {
            file.append('type', type)
        }
        _freedomAxios
        .post('corporate/profileCreation',
            {},
            {
                ignoreLoading: true,
                headers: {
                    authtoken: commonService.getAuthToken(),
                    'content-Type': 'application/json'
                }
            }
        )
    }
    const checkEntityIdAndProfileCreation = (file, type) => {

        let payLoad = {
            entityId : id
        };
        _freedomAxios
        .post('/corporate/getEntity',payLoad)
        .then((response) => {
            if(response.data.isSuccess){
                 if(action == "Login Creation")
                    profileCreation();
                else if(action == "Vas Addition")
                    vasAddition();
            }
            return response.data.message;
        })
    }
    
    useEffect(() => {
    //    entityIdList();
    }, [])
    



    return (
       <Grid>
           <Grid item>
               <Card sx = {{m:'3%', border:'5'}}>
                   <CardContent>
                   <TextField sx = {{margin : '1%'}}
                            id="outlined-helperText"
                            label = "Entity Id"
                             type="number"
                             required
                             onChange = {(e) => setEntityId(e.target.value)}
                        />
                       {/* <Select  sx={{ m: 1, minWidth: 120 }}
                        required = {true}
                       value={entityId}
                       onChange={(ev) => { setEntityId(ev.target.value) }}
                       renderValue={(selected) => selected}
                       label="Entity Id"
                       labelId="demo-simple-select-helper-label"
                       id="demo-simple-select-helper">
                    {corporateList.map((val,index) => 
                       (
                           <MenuItem sx={{ py: 0 }} value={val.Id} key={index}>
                               <ListItemText primary={val.entity} />
                           </MenuItem>
                       ))
                       }
                    </Select> */}
                
                {entityId ? <FormControl sx={{ m: 1, minWidth: 120 }}>
                <InputLabel id="demo-simple-select-helper-label">Action </InputLabel>
                <Select
                labelId="demo-simple-select-helper-label"
                id="demo-simple-select-helper"
                value={action}
                label="Action"
                onChange={(e) => setAction(e.target.value)}
                >
                    {ActionPerform.map((val,index) => (<MenuItem sx={{ py: 0 }} value={val} key={index}>
                               <ListItemText primary={val} />
                    </MenuItem>))}
                </Select>
                </FormControl> : <></>}
                {
                    action &&  <Button sx = {{m : '3%', minWidth: '120px'}}
                    variant="contained" onClick = { () => downloadFile(sampleFileUrl[action])}> Sample File </Button>
                }
               { entityId && action ? <StyledDropzone uploadStatus={uplaodStatus} submitFile={(file, type) => {
                   if(action == "Vas Addition") return vasAddition(file,type)
                   else if(action == "Login Creation") return profileCreation(file, type);
               } } /> : <></>}
               </CardContent>
               </Card>
               
           </Grid>
       </Grid>
    )

}